// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter__vF6tC","counterDark":"Counter_counterDark__2CMZP","count":"Counter_count__L8NHf","btn":"Counter_btn__3l378","btnDark":"Counter_btnDark__1PECK"};